import { useEffect } from 'react';
import { useHasFeatureFlag } from '../../selectors/useHasFeatureFlag';

/**
 * Custom hook to dynamically update the document title based on:
 * Feature flag: pinecone.zillow-closing (determines brand: zillow vs spruce)
 * 
 * When Zillow Closing is enabled: "Zillow Closing"
 * When Zillow Closing is disabled: "Pinecone - Spruce"
 */
export const useDocumentTitle = () => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');

  useEffect(() => {
    const title = isZillowClosingEnabled ? 'Zillow Closing' : 'Pinecone - Spruce';
    document.title = title;
  }, [isZillowClosingEnabled]);
};

